import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {Redirect} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ProtectedLayout } from "./Common/Components/ProtectedLayout";

import   Layout   from "./Common/Components/Layout";
import { RestoreSession } from "./Common/Components/RestoreSession";
import { Maintenance } from "../src/Login/Under-Maintenance";
import { Login } from "./Login/Login";
import { Logout } from "./Login/Logout";
import { PunchLogin } from "./Login/PunchLogin";
import { PunchInOut } from "./Modules/PunchInOut/PunchInOut";
import { Home } from "./Modules/Home/Home";
import { Vendor } from "./Modules/Vendor";
import './Common/Assets/Styles/globals.css';

import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import  Header  from "./Common/Components/Header";
import moment from 'moment-timezone'; // Import moment-timezone


const App: React.FC = () => {
  let appClassName: string = "App";
  if (window.innerWidth <= 1200 && window.innerWidth >= 1000) {
    appClassName = `${appClassName} small-width`;
  }

  // Set the default timezone to New York
  React.useEffect(() => {
    moment.tz.setDefault("America/New_York");
  }, []);


  return (
    <div  >
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {  
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/punch-login" component={PunchLogin} />
          <Route exact path="/punch-in-out" component={PunchInOut} />
          <Route exact path="/Vendor" component={Vendor} />

         
          <Route path="/Under-Maintenance" component={Maintenance} />
          <Route path="/RestoreSession" component={RestoreSession} />
          <Route path="/" component={ProtectedLayout}> 
          {/* <Route path="/" component={Header} /> */}
        </Route>
         
        </Switch>
      </Router> }  

{/* {  <Router>
      <Switch>
        <Route exact path="/login" component={Login}/>
        <Route exact path="/logout" component={Logout} />
          <Route exact component={ProtectedLayout} />
          <Route path="Home">
            <Route exact component={Home} />
          </Route>
          
        
      </Switch>
    </Router>  } */}
    </div>
  );
};

export default App;
